export const RELEASED = 'RELEASED' as const;
export const UNRELEASED = 'UNRELEASED' as const;
export const ARCHIVED = 'ARCHIVED' as const;

const statuses = [RELEASED, UNRELEASED, ARCHIVED];

export default statuses;
